import React from 'react';
import { Sidebar, Feed, Widgets } from './components';
import { makeStyles } from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core';
import { desktopScreenMinWidth } from './constants/css';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    height: '100vh',
    maxWidth: '1300px',
    marginLeft: 'auto',
    marginRight: 'auto',
    padding: '0 10px'
  }
});

function App() {
  const cssClasses = useStyles();
  const isDesktopScreen = useMediaQuery(`(min-width:${desktopScreenMinWidth})`);

  return (
    <div className={cssClasses.root}>
      <Sidebar />
      <Feed />
      {isDesktopScreen && <Widgets />}
    </div>
  );
}

export default App;
